import React from 'react';

export const Users = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.79999 9.8C3.79999 7.14903 5.94902 5 8.59999 5C11.251 5 13.4 7.14903 13.4 9.8C13.4 12.451 11.251 14.6 8.59999 14.6C5.94902 14.6 3.79999 12.451 3.79999 9.8Z'
                fill='currentColor'
            />
            <path
                d='M2.35984 17.6198C2.49921 17.2415 2.86245 17 3.2656 17H13.9344C14.3376 17 14.7008 17.2415 14.8402 17.6198C15.1904 18.5704 15.8 20.4228 15.8 21.8C15.8 23.1772 15.1904 25.0296 14.8402 25.9802C14.7008 26.3585 14.3376 26.6 13.9344 26.6H3.2656C2.86245 26.6 2.49921 26.3585 2.35984 25.9802C2.00961 25.0296 1.40002 23.1772 1.40002 21.8C1.40002 20.4228 2.00961 18.5704 2.35984 17.6198Z'
                fill='currentColor'
            />
            <path
                d='M20.6 12.2C20.6 9.54906 22.749 7.40002 25.4 7.40002C28.0509 7.40002 30.2 9.54906 30.2 12.2C30.2 14.851 28.0509 17 25.4 17C22.749 17 20.6 14.851 20.6 12.2Z'
                fill='currentColor'
            />
            <path
                d='M19.1598 20.0198C19.2992 19.6415 19.6624 19.4 20.0656 19.4H30.7344C31.1376 19.4 31.5008 19.6415 31.6402 20.0198C31.9904 20.9705 32.6 22.8229 32.6 24.2C32.6 25.5772 31.9904 27.4296 31.6402 28.3802C31.5008 28.7585 31.1376 29 30.7344 29H20.0656C19.6624 29 19.2992 28.7585 19.1598 28.3802C18.8096 27.4296 18.2 25.5772 18.2 24.2C18.2 22.8229 18.8096 20.9705 19.1598 20.0198Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default Users;
